import script from "./PortfolioDashboardScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioDashboardScreen.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioDashboardScreen.vue?vue&type=style&index=0&id=03f636da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03f636da"]])

export default __exports__